var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row gy-10 gx-xl-10"},[_c('div',{staticClass:"col-xl-12"},[_c('CotationSearch',{attrs:{"compact":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }